import { createSlice } from '@reduxjs/toolkit';
import {
  getGroupStatusData,
  getOperationsSnaphot,
  getAgronomist,
  getSeasonIndexData,
  getSubDistrictData,
  getSrAgronomist,
} from './action';
import { RizeUser } from 'types/common';

export type DashboardState = {
  groupsData?: unknown | undefined;
  isGroupsDataLoading: boolean;
  opsSnapshot?: unknown | undefined;
  snapShotLoading: boolean;
  agronomist?: RizeUser[];
  isAgronomistLoading: boolean;
  srAgronomist: RizeUser[];
  isSrAgronomistLoading: boolean;
  seasonIndexData?: unknown[];
  subDistrict?: unknown[];
  isSubDistrictLoading: boolean;
};

const initialState: DashboardState = {
  groupsData: {},
  isGroupsDataLoading: false,
  opsSnapshot: {},
  snapShotLoading: false,
  agronomist: [],
  isAgronomistLoading: false,
  srAgronomist: [],
  isSrAgronomistLoading: false,
  seasonIndexData: [],
  subDistrict: [],
  isSubDistrictLoading: false,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    init(state) {
      state.isGroupsDataLoading = false;
      state.snapShotLoading = false;
      state.isAgronomistLoading = false;
      state.isSrAgronomistLoading = false;
      state.isSubDistrictLoading = false;
      return state;
    },
    resetDashboardData(state) {
      return {
        ...state,
        groupsData: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGroupStatusData.pending, (state) => {
      state.isGroupsDataLoading = true;
      state.groupsData = {};
      return state;
    });
    builder.addCase(getGroupStatusData.fulfilled, (state, action) => {
      state.isGroupsDataLoading = false;
      state.groupsData = action.payload;
      return state;
    });
    builder.addCase(getGroupStatusData.rejected, (state) => {
      state.isGroupsDataLoading = false;
      state.groupsData = undefined;
      return state;
    });
    builder.addCase(getOperationsSnaphot.pending, (state) => {
      state.opsSnapshot = {};
      state.snapShotLoading = true;
      return state;
    });
    builder.addCase(getOperationsSnaphot.fulfilled, (state, action) => {
      state.opsSnapshot = action.payload;
      state.snapShotLoading = false;
      return state;
    });
    builder.addCase(getOperationsSnaphot.rejected, (state) => {
      state.snapShotLoading = false;
      return state;
    });
    builder.addCase(getAgronomist.pending, (state) => {
      state.isAgronomistLoading = true;
      state.agronomist = [];
      return state;
    });
    builder.addCase(getAgronomist.fulfilled, (state, action) => {
      state.isAgronomistLoading = false;
      state.agronomist = action.payload;
      return state;
    });
    builder.addCase(getAgronomist.rejected, (state) => {
      state.isAgronomistLoading = false;
      return state;
    });

    builder.addCase(getSrAgronomist.pending, (state) => {
      state.isSrAgronomistLoading = true;
      state.srAgronomist = [];
      return state;
    });
    builder.addCase(getSrAgronomist.fulfilled, (state, action) => {
      state.isSrAgronomistLoading = false;
      state.srAgronomist = action.payload;
      return state;
    });
    builder.addCase(getSrAgronomist.rejected, (state) => {
      state.isSrAgronomistLoading = false;
      return state;
    });

    builder.addCase(getSubDistrictData.pending, (state) => {
      state.isSubDistrictLoading = true;
      state.subDistrict = [];
      return state;
    });
    builder.addCase(getSubDistrictData.fulfilled, (state, action) => {
      state.isSubDistrictLoading = false;
      state.subDistrict = action.payload;
      return state;
    });
    builder.addCase(getSubDistrictData.rejected, (state) => {
      state.isSubDistrictLoading = false;
      return state;
    });
    builder.addCase(getSeasonIndexData.fulfilled, (state, action) => {
      state.seasonIndexData = action.payload;
      return state;
    });
    builder.addCase(getSeasonIndexData.rejected, (state) => {
      return state;
    });
  },
});

export const { init, resetDashboardData } = dashboardSlice.actions;

export default dashboardSlice.reducer;
